import { computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { DownloadFileButton } from "../Buttons/DownloadFileButton";
import { EditButton } from "../Buttons/EditButton";
import { FavouriteButton } from "../Buttons/FavouriteButton";
import { FullScreenButton } from "../Buttons/FullScreenButton";
import { HandButton } from "../Buttons/Pdf/HandButton";
import { RotateClockwiseButton } from "../Buttons/Pdf/RotateClockwiseButton";
import { RotateCounterClockwiseButton } from "../Buttons/Pdf/RotateCounterClockwiseButton";
import { ShareButtonReader } from "../Buttons/ShareButtonReader";
import * as DocumentManagement from "../DocumentManagement";
import { MetaDataInfoComponent } from "../Reader/MetaDataInfoComponent";
import { AppStore } from "../Stores/AppStore";
import { FavouriteDataStore } from "../Stores/FavouriteDataStore";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { FeedbackButton } from "../Buttons/FeedbackButton";

export enum ReaderToolbarMode {
	Default,
	PDF,
	Image,
	Video
}

interface IReaderToolbarProps {
	id: string;
	docId: string;
	docLanguage: string;
	collectionId: string;
	downloadName: string;
	canDownload: boolean;
	extension: string;
	mode: ReaderToolbarMode;
	fileName: string;
	onRotateClockwise?: () => void;
	rotateClockwiseDisabled?: boolean;
	onRotateCounterClockwise?: () => void;
	rotateCounterClockwiseDisabled?: boolean;
	originalFilename: string;
	isDeleted: boolean;
}

@observer
export class ReaderToolbarPart extends React.Component<IReaderToolbarProps, {}> {

	@computed get favouriteState(): number {
		if (FavouriteDataStore.favouriteDocs.length > 0) {
			return FavouriteDataStore.isFavourite(this.props.docId, this.props.docLanguage) ? 2 : 1;
		} else {
			return 1;
		}
	}

	handleAddFavourites = () => {
		if (FavouriteDataStore.isFavourite(this.props.docId, this.props.docLanguage)) {
			FavouriteDataStore.removeFromFavourite(this.props.docId, this.props.docLanguage);
		}
		else {
			FavouriteDataStore.addToFavourite(this.props.docId, this.props.docLanguage);
		}
	}

	handleEditDocument = () => {
		DocumentManagement.getCollectionHierarchyAsync(this.props.collectionId).then((result: DocumentManagement.CollectionHierarchy) => {
			let path = `${Urls.collections}/${this.props.collectionId}/documents/${this.props.docId}`;
			let treepath = `?treepath=${result.parentGuids.join(",")}`;
			if (treepath) {
				treepath += `,${this.props.collectionId}`;
				path += treepath;
			}
			AppStore.keepOnPage(path, true);
		});
	}

	render() {
		return <span className="buttongroup is--buttongroup-right">
			{this.props.canDownload ? <DownloadFileButton id={this.props.id} ext={this.props.extension} fileName={this.props.downloadName} testId="downloadButton" /> : null}
			{AppStore.context.sessionDetails.isDocumentManager && !AppStore.context.sessionDetails.isApp ? <EditButton onClick={this.handleEditDocument} title={Strings.reader.editButtonTooltip} /> : null}
			<FeedbackButton fileName={this.props.fileName} />
			<ShareButtonReader
				title={Strings.reader.shareDeepLinkButtonTooltip}
				docId={this.props.docId}
				isDeleted={this.props.isDeleted}
				fileName={this.props.fileName}
				originalFilename={this.props.originalFilename}
				extension={this.props.extension}
				docLanguage={this.props.docLanguage}
			/>
			<MetaDataInfoComponent fileId={this.props.id} />
			<FavouriteButton switchState={this.favouriteState} onClick={this.handleAddFavourites} />
			{this.props.mode === ReaderToolbarMode.PDF || this.props.mode === ReaderToolbarMode.Image ? <RotateClockwiseButton id="cusPageRotateCw" onClick={this.props.onRotateClockwise} disabled={this.props.rotateClockwiseDisabled} /> : null}
			{this.props.mode === ReaderToolbarMode.PDF || this.props.mode === ReaderToolbarMode.Image ? <RotateCounterClockwiseButton id="cusPageRotateCcw" onClick={this.props.onRotateCounterClockwise} disabled={this.props.rotateCounterClockwiseDisabled} /> : null}
			{this.props.mode === ReaderToolbarMode.PDF ? <HandButton id="cusToggleHandTool" /> : null}
			{this.props.mode !== ReaderToolbarMode.Video ? <>
				<span className="toolbar__splitter"></span>
				<FullScreenButton id="cusFullScreen" />
			</> : null}
		</span>;
	}
}